import React from "react";
import PageTemplate from "../../componentes/PageTemplate";

export default function Eventos() {
    return(
        <PageTemplate>
                <h3>Eventos que participei como ouvinte</h3>
        </PageTemplate>
    )
}